import { opaccAjaxPlugin, opaccLocalStoragePlugin } from '../opacc.static.js';

/** @module filter */

/**
 * Funktionalität zur Aktualisierung des Filterkriteriums.
 */
export class OpaccFilterCriterias {
	constructor() {
		this.filterSelectorClass = '.opc-filter-set .filter-set-list';
		this.filterSelector = document.querySelector(this.filterSelectorClass) || undefined;
		this.filterInUrl = this.filterSelector !== undefined ? (this.filterSelector.dataset.opFilterselectioninurl == 'true') : false;
		this.hasRdFilter = document.querySelectorAll('.opc-filter[data-op-groupid]').length > 0;
		this.ajaxPagelayout = 'asyn';
		this.catGroupId = 'cat';

		if (typeof opaccFilterCriteriasData === 'undefined') {
			window.opaccFilterCriteriasData = {};
		}
	}

	/**
	 *
	 *
	 * @param {*} attrName
	 * @param {*} attrValue
	 * @param {boolean} [ajaxReq=true]
	 * @param {*} [groupId=null]
	 * @param {*} [filterId=null]
	 */
	add(attrName, attrValue, ajaxReq = true, groupId = null, filterId = null) {
		if (!groupId) {
			groupId = this.catGroupId;
		}

		let data = {
			attrName: attrName,
			attrValue: attrValue,
			FilterId: filterId
		};
		data = this.hookBeforeAdd(data);

		if(window.opaccFilterCriteriasData[groupId] === undefined){
			window.opaccFilterCriteriasData[groupId] = [];
		}
		window.opaccFilterCriteriasData[groupId].push({
			AttrName: data.attrName,
			Value: data.attrValue,
			FilterId: filterId
		});

		this.hookAfterAdd();
		if (ajaxReq) {
			this.sendAjaxRequest();
		}
	}

	/**
	 *
	 *
	 * @param {*} [attrName=null]
	 * @param {*} [attrValue=null]
	 * @param {boolean} [ajaxReq=true]
	 * @param {*} [groupId=null]
	 * @param {*} [filterId=null]
	 * @param {*} [initFilter=null]
	 * @param {boolean} [resetAll=false]
	 */
	remove(attrName = null, attrValue = null, ajaxReq = true, groupId = null, filterId = null, initFilter = null, resetAll = false) {
		if (!groupId) {
			groupId = this.catGroupId;
		}

		let data = {
			attrName: attrName,
			attrValue: attrValue,
			FilterId: filterId
		};
		data = this.hookBeforeRemove(data);

		if (!data.attrName) {
			if (resetAll) {
				Array.from(Object.keys(window.opaccFilterCriteriasData)).forEach(key => {
					window.opaccFilterCriteriasData[key] = [];
				});
			}
			else {
				window.opaccFilterCriteriasData[groupId] = [];
			}
		}
		else {
			if(window.opaccFilterCriteriasData[groupId]) {
				// do reverse-loop for removing array-element
				let i = window.opaccFilterCriteriasData[groupId].length;
				const noValue = '#novalue';
				while (i--) {
					if ((data.attrValue === null && data.attrName === window.opaccFilterCriteriasData[groupId][i].AttrName) ||
						(data.attrValue === window.opaccFilterCriteriasData[groupId][i].Value && data.attrName === window.opaccFilterCriteriasData[groupId][i].AttrName) ||
						(data.attrValue === noValue && data.attrName === window.opaccFilterCriteriasData[groupId][i].AttrName)) {
						window.opaccFilterCriteriasData[groupId].splice(i, 1);
					}
					else if ((data.attrValue === null && data.FilterId === window.opaccFilterCriteriasData[groupId][i].FilterId) ||
							 (data.attrValue === window.opaccFilterCriteriasData[groupId][i].Value && data.FilterId === window.opaccFilterCriteriasData[groupId][i].FilterId) ||
							 (data.attrValue === noValue && data.FilterId === window.opaccFilterCriteriasData[groupId][i].FilterId)) {
							 window.opaccFilterCriteriasData[groupId].splice(i, 1);
					}
				}
			}
		}

		if (initFilter) {
			let obj = JSON.parse(initFilter);
			Array.from(Object.keys(obj)).forEach(group => {
				Array.from(Object.keys(obj[group])).forEach(filter => {
					Array.from(obj[group][filter]).forEach(value => {
						let filterId = `${group}-${filter}`;
						this.add('', value, false, group, filterId);
					});
				});
			});
		}

		this.hookAfterRemove();
		if (ajaxReq) {
			this.sendAjaxRequest();
		}
	}

	/**
	 *
	 *
	 * @param {*} attrName
	 * @param {*} attrValue
	 * @param {boolean} [ajaxReq=true]
	 * @param {*} [groupId=null]
	 * @param {*} [filterId=null]
	 */
	change(attrName, attrValue, ajaxReq = true, groupId = null, filterId = null) {
		if (!groupId) {
			groupId = this.catGroupId;
		}

		let data = {
			attrName: attrName,
			attrValue: attrValue,
			FilterId: filterId
		};
		data = this.hookBeforeChange(data);
		let changed = false;

		if(window.opaccFilterCriteriasData[groupId]) {
			Array.from(window.opaccFilterCriteriasData[groupId]).forEach(i => {
				if (data.attrName === i.AttrName) {
					i.Value = data.attrValue;
					changed = true;
				}
			});
		}

		// Criteria not exist
		if (!changed) {
			this.add(data.attrName, data.attrValue, false, groupId, filterId);
		}

		this.hookAfterChange();

		if (ajaxReq) {
			this.sendAjaxRequest();
		}
	}

	/**
	 *
	 *
	 * @param {HTMLElement} filterwrapper Wrapper des aktuellen Filterfeldes
	 * @returns {Array} Alle Inputfilter-Elemente innerhalb eines Filtersets
	 */
	prepareFilterCriterias(filterwrapper) {
		let wrapper = filterwrapper.closest(this.filterSelectorClass);
		let elements = [...wrapper.querySelectorAll('.op-form-input:not([readonly])'), ...wrapper.querySelectorAll('.opc-input:not([readonly])')].filter(elem => {
			let elemWrapper = elem.closest('.opc-filter');
			if (elemWrapper && elemWrapper.querySelector('.select-list') === null) {
				return elem;
			}
		});
		return elements;
	}

	/**
	 *
	 *
	 */
	sendAjaxRequest() {
		let data = {};
		let url = window.location.pathname;
		let qryString = window.location.search.substring(1);
		let qryStringFilter = '';

		if (qryString.length > 0) {
			let qryStringObj = JSON.parse('{"' + decodeURI(qryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"').replace(/\\/g,'\\\\') + '"}');
			for (let key in qryStringObj) {
				if (key.substring(0, 3) === 'cf-' || key.substring(0, 4) === 'ppos' || key.substring(0, 6) === 'paging' || window.opaccFilterCriteriasData[key] != undefined) {
					delete qryStringObj[key];
				}
			}
			qryString = opaccAjaxPlugin.objectToQuerystring(qryStringObj, true, false);
		}

		if (this.hasRdFilter) {
			let selectionKeys = Object.keys(window.opaccFilterCriteriasData);
			let selectionValues = Object.values(window.opaccFilterCriteriasData);

			selectionValues.forEach((arr, idx) => {
				let key = selectionKeys[idx];
				let obj = {};

				arr.forEach(criteria => {
					let id = key != this.catGroupId ? criteria.FilterId.substring(`${key}-`.length) : criteria.FilterId;

					if (obj[id]) {
						obj[id].push(criteria.Value);
					} else {
						obj[id] = [criteria.Value];
					}
				});

				let value = JSON.stringify(obj);
				data[key] = value;

				if (value != '{}') {
					let valueEncoded = encodeURIComponent(value);
					let valueBase64 = window.btoa(valueEncoded);
					let valueBase64UrlEncoded = encodeURIComponent(valueBase64);

					qryStringFilter += `${key}=${valueBase64UrlEncoded}&`;
				}
			});

			if (qryStringFilter) {
				qryStringFilter = qryStringFilter.substring(0, qryStringFilter.length-1);
				qryStringFilter = qryString.length > 0 ? `?${qryString}&${qryStringFilter}` : `?${qryStringFilter}`;
			}
			else if (qryString.length > 0) {
				qryStringFilter = `?${qryString}`;
			}

			url = `${window.location.pathname}${qryStringFilter}`;
		}
		else if (this.filterInUrl) {
			let selection = window.opaccFilterCriteriasData[this.catGroupId];
			if (selection) {
				data = selection.reduce((obj, item) => {
					obj[item.AttrName] = obj[item.AttrName] || [];
					obj[item.AttrName].push(item.Value.replace(/\[|\]/gi, ''));
					return obj;
				}, Object.create(null));
			}

			let i = 0;
			for (let key in data) {
				let delimiter = i > 0 ? '&' : '';
				qryStringFilter += `${delimiter}${key}=${encodeURIComponent(data[key].join('|'))}`;
				i++;
			}

			if (qryStringFilter) {
				qryStringFilter = qryString.length > 0 ? `?${qryString}&${qryStringFilter}` : `?${qryStringFilter}`;
			}
			else if (qryString.length > 0) {
				qryStringFilter = `?${qryString}`;
			}

			url = `${window.location.pathname}${qryStringFilter}`;
		}
		else {
			let selection = window.opaccFilterCriteriasData[this.catGroupId];
			if (selection) {
				data = {
					selection: JSON.stringify(selection)
				};
			}

			url += qryString.length > 0 ? `?${qryString}&pagelayout=${this.ajaxPagelayout}` : `?pagelayout=${this.ajaxPagelayout}`;
		}

		data = this.hookBeforeReturnPrepareDataSubmission(data);
		this.hookBeforeSendAjaxRequest();

		opaccLocalStoragePlugin.removePersistentView(opaccLocalStoragePlugin.getCurrentURI());
		opaccAjaxPlugin.fetchAsynPostForm(url, data, this.refreshResultList.bind(this), this.asyncErrorHandler.bind(this), true);

		if (this.hasRdFilter || this.filterInUrl) {
			history.replaceState(null, null, url);
		}
	}

	/**
	 * Ist es ein Auswahlfilter wo die Daten asynchron geladen werden?
	 *
	 * @param selector selector als Objekt
	 * @returns Boolean
	 */
	isSelectionFilterAsyncDataload(selector) {
		return Boolean(selector) === true;
	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	refreshResultList(response) {
		response = this.hookBeforeRefreshResultList(response);

		let targetSelector = '.content';
		let htmlObj = document.createElement('div');
		htmlObj.innerHTML = response.dataAsHtml;
		document.querySelector(targetSelector).innerHTML = htmlObj.querySelector(targetSelector).innerHTML;

		this.hookAfterRefreshResultList(response);

		this.firePseudoChangeEvent();
	}

	/**
	 * Change-Event triggern, um asynchrone Change-Operationen auszuführen
	 * @private
	 * @ignore
	 */
	firePseudoChangeEvent() {
		let triggerEvent = new Event('change');
		document.querySelector('.content').dispatchEvent(triggerEvent);
	}

	// ---------------------------------

	/**
	 *
	 *
	 * @param {*} error
	 */
	asyncErrorHandler(error) {
		// eslint-disable-next-line no-console
		console.error('Request failed: ', error.message);
		this.hookAfterAsyncErrorHandler(error);
	}

	/**
	 *
	 *
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeAdd(data) {return data;}

	/**
	 *
	 *
	 */
	hookAfterAdd() {}

	/**
	 *
	 *
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeRemove(data) {return data;}

	/**
	 *
	 *
	 */
	hookAfterRemove() {}

	/**
	 *
	 *
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeChange(data) {return data;}

	/**
	 *
	 *
	 */
	hookAfterChange() {}

	/**
	 *
	 *
	 */
	hookBeforeSendAjaxRequest(){}

	/**
	 *
	 *
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeReturnPrepareDataSubmission(data){ return data;}

	/**
	 *
	 *
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeRefreshResultList(data) {return data;}

	/**
	 *
	 *
	 * @param {*} data
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterRefreshResultList(data){}

	/**
	 *
	 *
	 * @param {*} error
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterAsyncErrorHandler(error){}
}